import type { TableColumns } from '@ohpen/enso-ui';

import type { ParameterEntry } from '@config/interfaces';

/** The systems the parameters came from, so the filter offers exactly those. */
export const SOURCE_LIST_NAME = 'parameterSources';

/** The kinds of value a parameter holds, named the way the reader is told them. */
export const DATA_TYPE_LIST_NAME = 'parameterDataTypes';

export const parameterColumns: TableColumns<ParameterEntry> = [
  {
    title: 'config.columns.source',
    dataIndex: 'source',
    key: 'source',
    width: 140,
    options: { filter: 'select', listName: SOURCE_LIST_NAME, sorter: true, filterOptions: { allowedModes: ['anyMatches'] } },
  },
  {
    title: 'config.columns.parameter',
    dataIndex: 'name',
    key: 'name',
    width: 320,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.type',
    dataIndex: 'dataType',
    key: 'dataType',
    width: 120,
    options: {
      filter: 'select',
      listName: DATA_TYPE_LIST_NAME,
      format: { type: 'valueList' },
      filterOptions: { allowedModes: ['anyMatches'] },
    },
  },
  { title: 'config.columns.value', dataIndex: 'value', key: 'value', width: 280, options: { filter: 'search' } },
  {
    title: 'config.columns.purpose',
    dataIndex: 'description',
    key: 'description',
    options: { filter: 'search' },
    render: (description?: string) => description ?? '-',
  },
];
